export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
    const initAccommodationCarousel = () => {
      $('#acco-carousel .owl-carousel').owlCarousel({
        loop: true,
        margin: 20,
        responsiveClass: true,
        dots: false,
        autoWidth: true,
        autoplay: true,
        nav: false,
        items: 5,
        responsive: {
          0: {
            items: 1,
          },
          767: {
            items: 2,
            margin: 15,
          },
          1000: {
            items: 5,
          },
          1441: {
            items: 7,
          },
        },
      });
    };

    // count participant amount function
    const countParticipants = () => {
      let total= 0;
      const $inputEl = $('#ipt-amount-participants');
      const amount_baby = parseInt($('#amount_baby').val());
      const amount_kid = parseInt($('#amount_kid').val());
      const amount_adult = parseInt($('#amount_adult').val());
      if(amount_adult > 0){
        total += amount_adult;
      }
      if(amount_kid > 0){
        total += amount_kid;
      }
      if(amount_baby > 0){
        total += amount_baby;
      }
      if(total > 0){
        $inputEl.val(total);
      }else{
        $inputEl.val('');
      }
    }

    // minus/plus icons clicking function
    const onClickIcons = () => {
      $('.lvr-input-actions').on('click', '.lvr-icon', function() {
        // prepare elements
        const $this = $(this);
        const $inputEl = $this.parents('.form-row').find('.lvr-input');
        let currentNumber = $inputEl.val();

        // check class
        if($this.hasClass('icon-minus')){ // click to minus icon
          // only minus when > 0
          if(currentNumber>0) currentNumber--;
          else currentNumber = 0;
        }else{ // click to plus icon
          currentNumber++;
        }
        $inputEl.val(currentNumber).trigger('change');
        countParticipants();
      });
    }

    // on part number input changed
    const onPartNumberChanged = () => {
      $('.part-amounts-selection input[type=number]').change(() => { 
        countParticipants();
      });
    }

    const onSelectGroupChanged = () => {
      $('.tour-types-selection input[type=radio]').change(function(){
        const $inputEl = $('#ipt-tour-type');
        const selectedVal = $(this).val();
        $inputEl.val(selectedVal);
      });
    }

    // function show selections
    const toggleSelection = (type='') => {
      $('.lvr-selections').slideUp();
      let containerEl = '';
      if(type=='part-amounts'){
        containerEl = '.part-amounts-selection';
      }else{
        containerEl = '.tour-types-selection';
      }
      if(type != ''){
        setTimeout(() => {
          $(containerEl).slideDown();
        }, 200);
      }
    };
    
    $(document).click(function (evt) {
      evt.stopPropagation();
      const container = $('.lvr-selections, .lvr-search .form-control-group');

      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(evt.target) && container.has(evt.target).length === 0) {
        toggleSelection('');
      }
    });

    // show options on search bar function
    const initSearchbar = () => {
      $('#lvr-search-bar').on('click', '.lvr-amount-participants', function(){
        toggleSelection('part-amounts');
      }).on('click', '.lvr-trip-type', function(){
        toggleSelection('tour-type');
      });
    };

    initAccommodationCarousel();
    initSearchbar();
    onClickIcons();
    onPartNumberChanged();
    onSelectGroupChanged();
  },
  
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js